import { WidgetLocale } from 'types';
import { DEFAULT_WIDGET_LOCALE, WIDGET_LOCALES } from 'utils/constants';

export function isWidgetLocale(value: unknown): value is WidgetLocale {
  return WIDGET_LOCALES.includes(value as WidgetLocale);
}

/**
 * Resolves a runtime-provided value to a supported WidgetLocale by its primary
 * language subtag, so BCP 47 tags such as "fr-FR", "fr_CA" or "FR" all resolve
 * to "fr". Falls back to the default locale when the value is missing or its
 * language is unsupported.
 */
export function resolveWidgetLocale(value: unknown): WidgetLocale {
  if (typeof value !== 'string') {
    return DEFAULT_WIDGET_LOCALE;
  }

  const [language] = value.toLowerCase().split(/[-_]/);

  if (isWidgetLocale(language)) {
    return language;
  }

  return DEFAULT_WIDGET_LOCALE;
}
